import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import { BasicForm } from "@components/shared";

export default function AddForm(props) {
  const [isLoading, setLoading] = useState(false);

  const fields = [
    {
      name: "name",
      label: "Version Name",
      initialValue: "",
      required: false,
      schema: () => null,
    },
  ];

  function onSubmit(postData) {
    setLoading(true);
    axios
      .post(`/surveys/${props.id}/versions/`, postData)
      .then(() => {
        setLoading(false);
      })
      .then(() => props.onSubmit())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return <BasicForm fields={fields} loading={isLoading} onSubmit={onSubmit} />;
}
